import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/lib/Async'
import client from '../../helpers/client'
import CustomOption from './CustomOption'
import './index.scss'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    fontSize: 18,
    paddingLeft: 10
  })
}

const deserializeFranchise = (franchise) => {
  if(franchise && franchise.id && franchise.attributes) {
    return {
      value: franchise.id,
      label: franchise.attributes.name,
      attributes: franchise.attributes
    }
  }
  else {
    return null
  }
}

const deserializeFranchises = (serializedFranchises) => {
  return serializedFranchises.map(franchise => deserializeFranchise(franchise)).filter(franchise => franchise)
}

const InternalFranchiseAutocomplete = ({ franchises = [], inputId, selected, apiKey }) => {
  const [selectedOption, setSelectedOption] = useState(deserializeFranchise(selected))
  const [currentValue, setCurrentValue] = useState("")
  const inputRef = useRef(null)

  // Sync with HTML input
  const syncHtmlInput = () => {
    if (inputRef.current) {
      if (selectedOption) {
        inputRef.current.value = selectedOption.value
      } else {
        inputRef.current.value = ""
      }
    }
  }

  // Effect to handle initial setup and sync HTML input
  useEffect(() => {
    if (inputId) {
      inputRef.current = document.getElementById(inputId)
      syncHtmlInput()
    }
  }, [inputId])

  // Effect to sync HTML input when selectedOption changes
  useEffect(() => {
    syncHtmlInput()
  }, [selectedOption])

  const handleInputChange = (currentValue) => {
    setCurrentValue(currentValue)
  }

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption)
  }

  const handleLoadOptions = (inputValue, callback) => {
    client.get(`/api/v1/franchises/autocomplete.json?api_key=${apiKey}&text=${currentValue}`)
      .then(response => {
        const options = deserializeFranchises(response.data.data)
        callback(options)
      })
      .catch(error => {
        const { data, status } = error.response
        const { errors } = data
        const errorMessage = status === 422 ? errors.join(", ") : "Error contacting server"
        alert(errorMessage)
      })
  }

  return (
    <AsyncSelect
      cacheOptions
      name={"franchise_id"}
      loadOptions={handleLoadOptions}
      components={{ Option: CustomOption }}
      onInputChange={handleInputChange}
      onChange={handleChange}
      styles={customStyles}
      placeholder="Start typing..."
      noOptionsMessage={() => currentValue ? "Unable to find any matching franchises" : "Start typing to search for franchises"}
      defaultOptions={deserializeFranchises(franchises)}
      value={selectedOption}
      isClearable={true}
    />
  );
}

InternalFranchiseAutocomplete.propTypes = {
  franchises: PropTypes.array,
  inputId: PropTypes.string,
  selected: PropTypes.object,
  apiKey: PropTypes.string.isRequired,
}

export default InternalFranchiseAutocomplete
